import { render, staticRenderFns } from "./PrintBillWholesaleInvoice.vue?vue&type=template&id=a4c47422&scoped=true"
import script from "./PrintBillWholesaleInvoice.vue?vue&type=script&lang=js"
export * from "./PrintBillWholesaleInvoice.vue?vue&type=script&lang=js"
import style0 from "./PrintBillWholesaleInvoice.vue?vue&type=style&index=0&id=a4c47422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c47422",
  null
  
)

export default component.exports